export default __webpack_public_path__ + "static/media/hand.3577affc.svg";